import React from 'react';
import { MapPin } from 'lucide-react';
import { LocationBlock } from '../../components/LocationBlock';
export function Page31Location() {
  return <section className="py-24 bg-off-white" data-id="element-2799">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2800">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-2801">
          <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-2802">
            <MapPin className="w-3.5 h-3.5" data-id="element-2803" />
            Where to Find Us
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-2804">
            Storm Taekwondo · Farmington Hills, MI
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-2805">
            24786 Crestview, Farmington Hills, MI 48335 · Call{' '}
            <a href="tel:517-220-0621" className="text-storm-red font-bold hover:underline" data-id="element-2806">
              517-220-0621
            </a>
          </p>
        </div>
        <LocationBlock data-id="element-2807" />
      </div>
    </section>;
}